module.exports = {
  languages: ['en', 'ru', 'es'],
  currentLang: 'en',
  domain: 'veliky.net',
  loaderText: 'https://veliky.net',
  indexTitle: 'Eugene Veliky - Software Engineer',
  role: 'Role',
  readMore: 'Read more >>',
  close: 'x Close',
  linkTo: 'Link to',
  meta: {
    desc: 'Eugene Veliky is a Senior Software Engineer with rich experience in building websites',
    keywords: 'Front End, Full Stack, Vue, Wordpress, JavaScript, PHP, MySQL',
    title: 'Eugene Veliky - Software Engineer',
    type: 'website',
    image: 'icon.png',
  },
  header: {
    professions: 'Software Engineer',
    name: 'Eugene Veliky',
    skillsOn: '> Show skills <',
    skillsOff: 'x Hide x',
    links: {
      github: 'https://github.com/veliky/',
      linkedin: 'https://www.linkedin.com/in/eugenegreat/',
      share: '',
    },
  },
  experience: {
    title: 'My job',
    desc: ['Making websites since 2008.', 'From 2014 professionally.'],
    companies: {
      huumun: {
        name: 'Huumun',
        title: ['Digital', 'Solutions', 'Provider'],
        role: 'Senior Software Engineer',
        content: '&emsp;Huumun is an established company from UK with a long history. Specializing in digital solutions in the life sciences sector. Among their clients are world-famous pharmaceutical companies. While working in the development team, I was able to complete a couple of interesting projects for Jazz Pharmaceutical and Pfizer.',
      },
      smarteka: {
        name: 'Smarteka.ru',
        title: ['Social', 'Projects', 'Platform'],
        role: 'Lead Developer',
        content: '&emsp;Smarteka.com is a popular platform for social projects in many areas such as healthcare, culture, environment, education, entrepreneurship development and others. The functionality of the platform includes acceptance of application materials, moderation by industry experts, publication of approved projects and their results.<br>' +
                '&emsp;As a lead developer, I developed new parts of the project, completed a full redesign of the project, and collaborated with other members of the development team.',
      },
      socialbet: {
        name: 'Social.bet',
        title: ['Free', 'Contest', 'Platform'],
        role: 'Lead Developer',
        content: '&emsp;Social.bet was a startup whose purpose was competitions for sports fans. The project provided a wide range of gaming functionality, including odds for events from 10 different bookmakers, the ability to place bets for game currency and track statistics, different types of bets and types of competitions.<br>' +
                '&emsp;As a Lead Developer, I took part in the development from initial stage of the project, throughout the entire project I was involved in the creation and development of functionality on the front-end and back-end as well.<br>' +
                '&emsp;Unfortunately the project was closed during Covid cost cutting.',
      },
      ignet: {
        name: 'Ignet',
        title: ['Web Agency', 'Ignet Solutions'],
        role: 'Software Developer',
        content: '&emsp;Ignet was a dynamic website development studio. We were specialized in complex projects implemented in WordPress. Some of our favorite tasks included input and output of large amounts of data, optimization of speed, responsive templates, and finally the creation of countless custom plugins and themes to work with a wide variety of APIs and types of content.<br>' +
                '&emsp;This small company gave me a strong start in the form of experience working with different types of clients and projects in different areas. For almost 3 years, I have released more than 10 websites from scratch, and have taken part in the work of more than 30.',
      }
    },
    pets: {
      title: 'See pet projects >>',
      back: '<< Go back',
      list: {
        'embed-mixcloud-advanced': {
          title: ['Wordpress', 'Plugin'],
          name: 'Embed Mixcloud Advanced',
          content: '&emsp;I have always been interested in listening to music and creating projects. This time it led to the successful experience of publishing the plugin in the official WordPress repository.<br>' +
            '&emsp;The functionality of the project was specific to fans of the mixcloud.com music platform. The project was not popular and I decided to close it.',
        },
        'iframe-new-tab': {
          title: ['Chrome', 'Extension'],
          name: 'Iframe New Tab',
          content: '&emsp;I have long wanted to try to create a browser extension and when the right idea came up I did it. The functionality is not unique and primitive, but for me it was an experience of developing and publishing for a specific platform. The extension is still alive and can be installed even now!',
        },
        'spaze': {
          title: ['Mobile', 'website'],
          name: 'Spaze.ru',
          content: '&emsp;This was my first project with a first-level domain. It was of a reference nature, dedicated to users of one mobile social network. He was not widely known but had a stable small audience. At the moment you can see fragments of sites in the web archive.',
        },
        'sehack': {
          title: ['Mobile', 'website'],
          name: 'se-hack.wen.su',
          content: '&emsp;I created my first website back in 2008 using a phone with a screen resolution of 128x128. And although it was created using a primitive website builder, I already went beyond the scope and learned how to use HTML and CSS. And it was available on the Internet! So my friends and I were competed to see whose site was cooler.<br>' +
            '&emsp;Unfortunately, the hosting provider has closed and the site is no longer available.',
        },
      },
    },
  },
  skills: [
    'JavaScript',
    'Vue',
    'Nuxt.js',
    'Webpack',
    'SASS',
    'SCSS',
    'D3.js',
    'SVG',
    'BEM',
    'CSS3',
    'Photoshop',
    'Figma',
    'HTML5',
    'PHP',
    'MySQL',
    'WordPress',
    'WooCommerce',
    'Gutenberg',
    'WP-CLI',
    'Composer',
    'OOP',
    'Linux',
    'Localization',
    'REST APIs',
    'Payment APIs',
    'CRON',
    'GitLab',
    'Jira',
    'PhpStorm',
    'Slack',
    'Trello',
    'Software Engineering',
    'Android Development',
    'xDebug'
  ],
  hobbies: {
    btn: '<< My hobbies',
    gallery: {
      title: 'I like to take photos',
    },
    player: {
      title: 'And enjoy listening to',
      subtitle: 'Deep House music',
      prev: 'Previous',
      play: 'Play',
      next: 'Next',
      toggle: 'Expand or Minimize',
      info: {
        title: 'Loading...',
      }
    }
  }
}
